































import { IconSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import { useEventListener } from '@vueuse/core';
import { useToast } from '../toast.composable';
import type { Toast } from '../types/toast';

export default defineComponent({
  props: {
    toast: { type: Object as PropType<Toast>, required: true },
  },
  setup(props) {
    const { remove } = useToast();
    const toastProgress = ref<HTMLDivElement>();

    const style = computed(() => ({
      ['animation-name']: `width-animation`,
      ['animation-direction']: `forwards`,
      ['animation-duration']: `${props.toast.options.timeout}ms`,
      ['animation-timing-function']: 'linear',
    }));

    useEventListener(toastProgress, 'animationend', () => {
      remove(props.toast.id);
    });

    const textContent = computed(() => {
      if (typeof props.toast.content === 'string') {
        return props.toast.content;
      }
      return '';
    });

    return { toastProgress, style, IconSize, remove, textContent };
  },
});
